import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function ContactCTA() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    // Simulate submission
    setTimeout(() => {
      setStatus('success');
      setFormData({
        name: '',
        email: '',
        message: ''
      });
    }, 1000);
  };
  return <section className="py-16" data-id="element-55">
      <div className="relative rounded-3xl p-8 md:p-12 text-surface-tint bg-gradient-to-br from-brand-deep/95 to-brand-teal/[0.87] shadow-hero overflow-hidden" data-id="element-56">
        <span className="absolute -top-6 -right-2 font-display italic text-[200px] md:text-[260px] leading-none text-white/[0.06] select-none pointer-events-none" data-id="element-57">
          07
        </span>
        <div className="relative max-w-2xl mx-auto text-center mb-8" data-id="element-58">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-mint mb-4" data-id="element-59">
            Let's talk
          </p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-4" data-id="element-60">
            What's <span className="italic" data-id="element-61">eating your team's week?</span>
          </h2>
          <p className="text-lg text-[rgb(221,242,251)]" data-id="element-62">
            Tell us the bottleneck, the broken process, or the system you wish
            existed. We'll come back with a straight answer on whether we can
            help — no sales pitch.
          </p>
        </div>

        {status === 'success' ? <div className="max-w-md mx-auto bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center" data-id="element-63">
            <p className="text-lg font-semibold mb-2" data-id="element-64">
              Thanks for reaching out!
            </p>
            <p className="text-[rgb(221,242,251)]" data-id="element-65">
              We'll get back to you within 24 hours.
            </p>
          </div> : <form onSubmit={handleSubmit} className="relative max-w-md mx-auto space-y-4" data-id="element-66">
            <input type="text" placeholder="Your name" value={formData.name} onChange={e => setFormData({
          ...formData,
          name: e.target.value
        })} required className="w-full px-4 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-white/40" data-id="element-67" />
            <input type="email" placeholder="Your email" value={formData.email} onChange={e => setFormData({
          ...formData,
          email: e.target.value
        })} required className="w-full px-4 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-white/40" data-id="element-68" />
            <textarea placeholder="What's slowing your team down?" value={formData.message} onChange={e => setFormData({
          ...formData,
          message: e.target.value
        })} required rows={4} className="w-full px-4 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-white/40 resize-none" data-id="element-69" />
            <button type="submit" disabled={status === 'submitting'} className="w-full inline-flex items-center justify-center gap-2 text-brand-deep font-semibold rounded-xl px-6 py-3.5 bg-white transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-70">
              {status === 'submitting' ? 'Sending...' : 'Start the conversation'}
              <ArrowRight className="w-4 h-4" data-id="element-71" />
            </button>
          </form>}
      </div>
    </section>;
}